/**
 * Simple moving average line data for investing / ETP daily bars.
 * Window matches PostgreSQL stock_movingaverage_daily (n-bar SMA including partial windows).
 */

export function computeSmaLineData(bars, period) {
  if (!Array.isArray(bars) || bars.length === 0 || period < 1) {
    return [];
  }

  const out = [];
  for (let i = 0; i < bars.length; i += 1) {
    const start = Math.max(0, i - period + 1);
    let sum = 0;
    let count = 0;
    for (let j = start; j <= i; j += 1) {
      const close = bars[j].close;
      if (close != null && !Number.isNaN(close)) {
        sum += close;
        count += 1;
      }
    }
    if (count === 0) continue;
    out.push({ time: bars[i].time, value: sum / count });
  }
  return out;
}
